import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

import { Histogram } from '@/entities/histogram';
import EyeIcon from '@/shared/assets/icons/ui-kit/eye.svg';
import TrashIcon from '@/shared/assets/icons/ui-kit/trash.svg';
import { ShamefulAny } from '@/shared/lib/interfaces/utils';
import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/button';

const columnHelper = createColumnHelper<Histogram>();

export const createHistogramColumns = ({
	translate,
	onView,
	onDelete,
	histogramId,
}: {
	translate: TFunction<'tables'>;
	onView: (id: string) => void;
	onDelete: (id: string) => void;
	histogramId: string;
}): ColumnDef<Histogram, ShamefulAny>[] => [
	columnHelper.accessor((row) => row.name, {
		header: translate('histograms.head.name'),
		id: 'name',
		cell: (info) => info.getValue(),
	}),
	columnHelper.accessor((row) => row.created, {
		header: translate('histograms.head.created'),
		id: 'created',
		cell: (info) => info.getValue(),
	}),
	columnHelper.accessor((row) => row.startTime, {
		header: translate('histograms.head.start'),
		id: 'startTime',
		cell: (info) => info.getValue(),
	}),
	columnHelper.accessor((row) => row.endTime, {
		header: translate('histograms.head.end'),
		id: 'endTime',
		cell: (info) => info.getValue(),
	}),
	columnHelper.display({
		header: '',
		id: 'actions',
		cell: ({ row }) => {
			const id = row.original?.id;

			return (
				<Box align="center" gap={12}>
					<Button
						StartSvg={EyeIcon}
						onClick={() => onView(id)}
						padding="8px"
						variant={histogramId === id ? 'contained' : 'outlined'}
					/>
					<Button StartSvg={TrashIcon} onClick={() => onDelete(id)} padding="8px 9px" variant="error" />
				</Box>
			);
		},
	}),
];
